import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const CustomButton = styled(ButtonMui)`
    width: 16rem !important;    
    height: 3rem !important;
    margin: 0 !important;
`

export const ContainerButton = styled.div`
    display: flex;
    margin: 1rem;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    width: 100%;
`

export const CustomTextArea = styled(TextFieldMui)`
    margin: 0 !important;
    width: 48rem !important;
    height: 17rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const ContainerTextArea = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem;
    span{
        color: red;
    }
`

export const CustomLabelCount = styled.div`
    width: 140px;
`
